import React from 'react';
import AppRouter from './routes/AppRouter';
import { ThemeProvider } from './contexts/ThemeContext';
import './assets/styles/App.css';
import { User } from 'lucide-react';
import { UserProvider } from './contexts/UserContext';
import { Web3Provider } from './contexts/Web3Context';
import { WalletProvider } from './contexts/WalletContext';
import ErrorBoundary from './components/ErrorBoundary';
import ChatWidget from './components/ChatWidget';

function App() {
  return (
    <ThemeProvider>
      <UserProvider>
        <ErrorBoundary>
          <Web3Provider>
            <WalletProvider>
              <AppRouter />
            </WalletProvider>
          </Web3Provider>
        </ErrorBoundary>
        <ChatWidget />
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;